import { getTimeAgoString } from '@nx-frontend/shared/utils';

interface ListItemTimeAgoProps {
  timestamp: number;
}

export const ListItemTimeAgo: React.FC<ListItemTimeAgoProps> = ({ timestamp }) => {
  return <>{getTimeAgoString(timestamp)}</>;
};
